import { NextSeo } from 'next-seo';
import React from 'react';
import { useRouter } from 'next/router';
import cookie from 'js-cookie';
import { useTranslate } from '~/i18n';
import { withAuth } from '~/auth';
import { DhamenRequestsList } from '~/components/umrah-requests';
import PasswordPromptModal from '~/components/common/PasswordPromptModal';

const DhamenRequests = () => {
   const router = useRouter();
   const { translate } = useTranslate();
   const pswdCookies = cookie.get(`${process.env.NEXT_PUBLIC_PASSWORD_COOKIE_NAME}`);
   const isPswdVerified = !!pswdCookies;

   if (process.env.NEXT_PUBLIC_HAS_PRIVATE_ROUTES === 'true' && !isPswdVerified) {
      return <PasswordPromptModal queryPassword={String(router?.query?.password) || ''} />;
   }

   return (
      <>
         <NextSeo
            title={translate({
               id: 'pageTitles:dhamen requests',
            })}
         />
         <DhamenRequestsList />
      </>
   );
};

export default withAuth(DhamenRequests);
